import { eTipoPermissao } from "@/enums/ePermissoes";

export default [
 {
  description: "Fornecimento",
  path: "/merenda/merfornecimento",
  name: "merfornecimento",
  component: () => import("@/views/merenda/merfornecimento/Index.vue"),
  meta: {
   permissions: [eTipoPermissao.FORNECIMENTODEMATERIALNOVO_MENU_1900300499],
  },
  goesToMenu: true,
 },
 {
  description: "Cadastro de Fornecimento",
  path: "/merenda/merfornecimento/cadastro/:id?",
  parent: "merfornecimento",
  name: "merfornecimento_create",
  component: () => import("@/views/merenda/merfornecimento/InclusaoEdicao.vue"),
  meta: {
   permissions: [eTipoPermissao.FORNECIMENTODEMATERIALNOVO_MENU_1900300499],
  },
  goesToMenu: true,
 },
 {
  description: "Materiais do Fornecimento",
  path: "/merenda/merfornecimento/:id/itens",
  parent: "merfornecimento",
  name: "merfornecimento_itens",
  component: () => import("@/views/merenda/merfornecimento/Itens.vue"),
  meta: {
   permissions: [eTipoPermissao.FORNECIMENTODEMATERIALNOVO_MENU_1900300499],
  },
  goesToMenu: false,
 },
 {
  path: "/merenda/merfornecimento/:ano(\\d+)",
  redirect: (to: any) => ({
   name: "merfornecimento",
   query: {
    ...to.query,
    ano: String(to.params.ano),
   },
  }),
 },
]

